/**
 * Estimated Delivery Widget
 * Populates dates into any .estimated-delivery-widget on the page.
 * Uses IntersectionObserver so it works inside lazy/dynamic containers
 * like the mini-cart drawer (which Shopify morphs into the DOM).
 */
(function () {
  const LOCATION_URL = 'https://shopify-order-tracking-nine.vercel.app/api/get-location';

  // Cache the country fetch promise so we only hit the API once per page load
  let countryPromise = null;

  function getCountry() {
    if (!countryPromise) {
      countryPromise = fetch(LOCATION_URL)
        .then((r) => r.json())
        .then((d) => (d.country || '').toUpperCase())
        .catch(() => '');
    }
    return countryPromise;
  }

  function fmt(date) {
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  }

  async function fillWidget(widget) {
    // Avoid running twice on the same element
    if (widget.dataset.edReady === '1') return;
    widget.dataset.edReady = '1';

    const daysShipping     = parseInt(widget.dataset.daysShipping     || widget.getAttribute('data-days-shipping')     || 2,  10);
    const daysDomestic     = parseInt(widget.dataset.daysDomestic     || widget.getAttribute('data-days-domestic')     || 3,  10);
    const daysInternational= parseInt(widget.dataset.daysInternational|| widget.getAttribute('data-days-international') || 7,  10);
    const domesticCountry  = (widget.dataset.domesticCountry          || widget.getAttribute('data-domestic-country')  || 'IN').toUpperCase();

    const country = await getCountry();
    const deliveryDays = (country && country === domesticCountry) ? daysDomestic : daysInternational;

    const today = new Date();
    const shipped = new Date(today);
    shipped.setDate(today.getDate() + daysShipping);
    const delivered = new Date(today);
    delivered.setDate(today.getDate() + deliveryDays);

    const orderedEl   = widget.querySelector('.ed-ordered-date');
    const shippedEl   = widget.querySelector('.ed-shipped-date');
    const deliveredEl = widget.querySelector('.ed-delivered-date');

    if (orderedEl)   orderedEl.textContent   = fmt(today);
    if (shippedEl)   shippedEl.textContent   = fmt(shipped);
    if (deliveredEl) deliveredEl.textContent = fmt(delivered);
  }

  // Use IntersectionObserver: fires when the widget scrolls into view (or drawer opens)
  function observeWidget(widget) {
    if (widget.dataset.edObserved === '1') return;
    widget.dataset.edObserved = '1';

    const io = new IntersectionObserver((entries, obs) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          obs.unobserve(entry.target);
          fillWidget(entry.target);
        }
      }
    }, { threshold: 0 });

    io.observe(widget);
  }

  function initAll() {
    document.querySelectorAll('.estimated-delivery-widget').forEach(observeWidget);
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Watch for new widgets added dynamically (cart drawer morph/inject)
  const mo = new MutationObserver(() => {
    document.querySelectorAll('.estimated-delivery-widget:not([data-ed-observed="1"])').forEach(observeWidget);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
